import { IModalWindow } from '@hooks/useModalWindow';
import { ICaixaItem } from '@model/CaixaItem';
import React from 'react';
import { EnumCaixaTipoLancamento } from '@model/CaixaTipoLancamento';
import { CaixaRegistrarModal } from './CaixaRegistrarModal';

export type CaixaRegistrarDebitoModalProps = {
    modal: IModalWindow
    onCaixaItemRegistrado: (caixaItem: ICaixaItem) => void
}

export function CaixaRegistrarDebitoModal ({ modal, onCaixaItemRegistrado }: CaixaRegistrarDebitoModalProps) {
    return (
        <CaixaRegistrarModal 
            modal={modal}
            caixaTipoLancamento={EnumCaixaTipoLancamento.Debito}
            onCaixaItemRegistrado={onCaixaItemRegistrado}
        />
    )
}